const state = {
  isShowTemplateMaterialLibDialog: false,
  materialLib_Nav_Param: { materialType: '', navParam: 0 },
  isShowLibUseTemplateLoading: false,
  isShowFirstTemplateLoading: false,
  sideBarTemplate: null,
  isShowSideBarTemplateDialog: false
}

const getters = {
  ShowTemplateMaterialLibDialog: state => state.isShowTemplateMaterialLibDialog,
  MaterialLib_Nav_Param: state => state.materialLib_Nav_Param,
  ShowLibUseTemplateLoading: state => state.isShowLibUseTemplateLoading,
  ShowFirstTemplateLoading: state => state.isShowFirstTemplateLoading,
  SideBarTemplate: state => state.sideBarTemplate,
  ShowSideBarTemplateDialog: state => state.isShowSideBarTemplateDialog,
}


const mutations = {
  open_TemplateMaterialLibDialogMsg(state, data) {
    state.isShowTemplateMaterialLibDialog = true;
    state.materialLib_Nav_Param = data;
  },
  close_TemplateMaterialLibDialogMsg(state) {
    state.isShowTemplateMaterialLibDialog = false;
  },
  open_LibUseTemplateLoading(state) {
    state.isShowLibUseTemplateLoading = true;
  },
  close_LibUseTemplateLoading(state) {
    state.isShowLibUseTemplateLoading = false;
  },
  open_FirstTemplateLoading(state) {
    state.isShowFirstTemplateLoading = true;
  },
  close_FirstTemplateLoading(state) {
    state.isShowFirstTemplateLoading = false;
  },
  open_sideBarTemplate(state, data) {
    state.isShowSideBarTemplateDialog = true;
    state.sideBarTemplate = data.sideBarTemplate;
  },
  close_sideBarTemplate(state) {
    state.isShowSideBarTemplateDialog = false;
    state.sideBarTemplate = null;
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/templateMaterialLib.js